export var SeverityGrade;
(function (SeverityGrade) {
    SeverityGrade["A"] = "a";
    SeverityGrade["B"] = "b";
    SeverityGrade["C"] = "c";
    SeverityGrade["D"] = "d";
    SeverityGrade["E"] = "e";
})(SeverityGrade || (SeverityGrade = {}));
export const SeverityGradeOptions = Object.freeze(Object.values(SeverityGrade));
export var SeverityChange;
(function (SeverityChange) {
    SeverityChange["Unchanged"] = "unchanged";
    SeverityChange["Worsened"] = "worsened";
    SeverityChange["Improved"] = "improved";
})(SeverityChange || (SeverityChange = {}));
export const SeverityChangeOptions = Object.freeze(Object.values(SeverityChange));
export var CountermeasureCategory;
(function (CountermeasureCategory) {
    CountermeasureCategory["A0"] = "A0";
    CountermeasureCategory["A"] = "A";
    CountermeasureCategory["B"] = "B";
    CountermeasureCategory["C"] = "C";
    CountermeasureCategory["E1"] = "E1";
    CountermeasureCategory["E2"] = "E2";
    CountermeasureCategory["M"] = "M";
    CountermeasureCategory["S1"] = "S1";
    CountermeasureCategory["S2"] = "S2";
})(CountermeasureCategory || (CountermeasureCategory = {}));
export const CountermeasureCategoryOptions = Object.freeze(Object.values(CountermeasureCategory));
export var SoundnessRating;
(function (SoundnessRating) {
    SoundnessRating["I"] = "I";
    SoundnessRating["II"] = "II";
    SoundnessRating["III"] = "III";
    SoundnessRating["IV"] = "IV";
})(SoundnessRating || (SoundnessRating = {}));
export const SoundnessRatingOptions = Object.freeze(Object.values(SoundnessRating));
export const SeverityToSoundnessMap = {
    [SeverityGrade.A]: SoundnessRating.I,
    [SeverityGrade.B]: SoundnessRating.II,
    [SeverityGrade.C]: SoundnessRating.III,
    [SeverityGrade.D]: SoundnessRating.IV,
    [SeverityGrade.E]: null,
};
export var ProgressionStatus;
(function (ProgressionStatus) {
    ProgressionStatus["Progressive"] = "progressive";
    ProgressionStatus["Stable"] = "stable";
    ProgressionStatus["Unknown"] = "unknown";
})(ProgressionStatus || (ProgressionStatus = {}));
export const ProgressionStatusOptions = Object.freeze(Object.values(ProgressionStatus));
export var DamageCause;
(function (DamageCause) {
    DamageCause["AgingDeterioration"] = "aging_deterioration";
    DamageCause["DryingShrinkage"] = "drying_shrinkage";
    DamageCause["ThermalStress"] = "thermal_stress";
    DamageCause["StructuralStress"] = "structural_stress";
    DamageCause["GroundMovement"] = "ground_movement";
    DamageCause["FreezeThaw"] = "freeze_thaw";
    DamageCause["WaterInfiltration"] = "water_infiltration";
    DamageCause["GroundwaterPressure"] = "groundwater_pressure";
    DamageCause["ChlorideAttack"] = "chloride_attack";
    DamageCause["Carbonation"] = "carbonation";
    DamageCause["AlkaliSilicaReaction"] = "alkali_silica_reaction";
    DamageCause["ImpactDamage"] = "impact_damage";
    DamageCause["FireDamage"] = "fire_damage";
    DamageCause["ConstructionDefect"] = "construction_defect";
    DamageCause["InsufficientBackfill"] = "insufficient_backfill";
    DamageCause["JointDegradation"] = "joint_degradation";
    DamageCause["WaterErosion"] = "water_erosion";
    DamageCause["SeismicDamage"] = "seismic_damage";
})(DamageCause || (DamageCause = {}));
export const DamageCauseOptions = Object.freeze(Object.values(DamageCause));
export var AssessmentStatus;
(function (AssessmentStatus) {
    AssessmentStatus["Draft"] = "draft";
    AssessmentStatus["Confirmed"] = "confirmed";
    AssessmentStatus["Reviewed"] = "reviewed";
})(AssessmentStatus || (AssessmentStatus = {}));
export const AssessmentStatusOptions = Object.freeze(Object.values(AssessmentStatus));
